import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetSearchByCnpjUseCaseInterface } from 'domain/usecases/search-by-cnpj/get-search-by-cnpj';

export class RemoteGetSearchByCnpj implements GetSearchByCnpjUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetSearchByCnpjUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetSearchByCnpjUseCaseInterface.Params,
  ): Promise<GetSearchByCnpjUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url + '/' + `${params?.cnpj}`,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
